import {
  ArrowRightIcon,
  MapPinIcon,
  PersonStandingIcon,
  UsersIcon,
} from 'lucide-react'

import { useOnboardingStep } from 'components/hooks/employer_onboarding/useOnboardingStep'
import { Button, usePageTitle } from 'slab'

import { CenteredLayout } from '../CenteredLayout'
import { ContainerList } from '../ContainerList'

interface SetupAllowancesPageProps {
  assets?: {
    images?: Record<string, string>
  }
}
export function SetupAllowancesPage ({ assets }: SetupAllowancesPageProps) {
  usePageTitle('Allowances')

  const { navigateToPreviousStep, navigateToNextStep } = useOnboardingStep()
  const allowanceMapUrl = assets?.images?.['allowance-map'] ?? ''

  return (
    <CenteredLayout displaySupportLink>
      <CenteredLayout.Header
        heading={
          <>
            Each employee gets an{' '}
            <span className='bg-[linear-gradient(258deg,#FF5900_24.58%,#B700FF_50.19%,#4000FF_77.16%,#00BFFF_100%)] text-transparent bg-clip-text'>
              allowance
            </span>
          </>
        }
        subheading='The allowance is a specific amount of money that each employee receives every month to cover insurance and healthcare costs.'
      />
      <div className='mb-16'>
        <h2 className='heading-sm-regular mb-4 text-center'>
          Employees' insurance and healthcare costs will vary based on:
        </h2>
        <ContainerList>
          <ContainerList.Item icon={MapPinIcon} heading='Where they live'>
            Cost of living varies across the country –– more expensive regions
            will see higher insurance costs.
          </ContainerList.Item>
          <ContainerList.Item
            icon={PersonStandingIcon}
            heading='How old they are'
          >
            Older employees will generally face higher insurance costs.
          </ContainerList.Item>
          <ContainerList.Item icon={UsersIcon} heading='Number of dependents'>
            Those with families (spouses or children) require more coverage,
            therefore increasing costs.
          </ContainerList.Item>
        </ContainerList>
        <img
          src={allowanceMapUrl}
          aria-hidden
          className='block mt-10 w-full max-w-[26rem] mx-auto'
          width={887}
          height={480}
        />
      </div>
      <CenteredLayout.Buttons>
        <Button variant='secondary' onClick={navigateToPreviousStep}>
          Back
        </Button>
        <Button
          variant='primary'
          onClick={navigateToNextStep}
          rightIcon={ArrowRightIcon}
        >
          Ok got it!
        </Button>
      </CenteredLayout.Buttons>
    </CenteredLayout>
  )
}
